<template>
  <div>
    <ValidationObserver ref="formAdd">
      <form>
        <div class="breadcrumb-area pos-relative w-100">
          <!-- title -->
          <div class="row">
            <h5 class="col-sm-6 col-12">Import file</h5>
            <div class="col-sm-6 col-12 d-flex justify-content-end align-items-center">
              <b-button class="ml-2" @click="$router.push({ name: 'File' })"> Quay lại </b-button>
            </div>
          </div>
          <!-- content -->
          <div class="">
            <div class="row w-100">
              <div class="col-sm-6 mt-2">
                <ValidationProvider rules="required" vid="serviceType" name="Loại dịch vụ">
                  <div class="form-group row" slot-scope="{ errors }">
                    <label for="" class="col-sm-3 col-form-label"
                      >Loại dịch vụ<span style="color: red"> *</span></label
                    >
                    <div class="col-sm-9">
                      <Select2
                        v-model="formData.serviceType"
                        :options="serviceTypeOption"
                        placeholder="Chọn loại dịch vụ"
                      >
                      </Select2>
                      <p class="text-danger">{{ errors[0] }}</p>
                    </div>
                  </div>
                </ValidationProvider>
                <ValidationProvider rules="required" vid="regionId" name="Vùng">
                  <div class="form-group row" slot-scope="{ errors }">
                    <label for="" class="col-sm-3 col-form-label"
                      >Vùng<span style="color: red"> *</span></label
                    >
                    <div class="col-sm-9">
                      <Select2
                        v-model="formData.regionId"
                        :options="optionsRegion"
                        placeholder="Chọn vùng"
                      >
                      </Select2>
                      <p class="text-danger">{{ errors[0] }}</p>
                    </div>
                  </div>
                </ValidationProvider>
                <button
                  type="button"
                  class="font-medium f12 btn btn-outline-secondary"
                  @click="importFile"
                >
                  Import file
                </button>
              </div>
            </div>
          </div>
          <input
            style="display: none"
            ref="uploadFileExcel"
            @change="uploadFileExcel"
            type="file"
          />
        </div>
      </form>
    </ValidationObserver>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import { DeviceService } from '../../services/device.service'
  import { StaffService } from '@/services/staff.service'
  export default {
    data() {
      return {
        progressPercentage: 0,
        serviceType: '',
        showLoading: false,
        formData: {},
        serviceTypeOption: [
          { id: 'KPI_PAYMENT', text: 'KPI thanh toán' },
          { id: 'KPI_SELL', text: 'KPI bán hàng' },
        ],
        optionsRegion: [],
        dataUser: JSON.parse(localStorage.getItem('userData')),
      }
    },
    mounted() {
      this.fetchUser()
    },
    methods: {
      importFile() {
        const serviceType = this.formData.serviceType
        if (!serviceType) {
          this.showFailMx('Vui lòng chọn loại dịch vụ muốn import file.')
          return
        }
        this.$refs.uploadFileExcel.click()
      },
      async uploadFileExcel(file) {
        if (file.target.files.length === 0) return
        const allowedExtensions = /(\.xls|\.xlsx|\.csv|\.ods)$/i
        const checkFomat = allowedExtensions.exec(file.target.files[0].name)
        if (!checkFomat) {
          this.showFailMx('Định dạng không hợp lệ !')
          this.$refs.uploadFileExcel.value = null
          return
        }
        const formdata = new FormData()
        formdata.append('file', file.target.files[0])
        formdata.append('type', this.formData.serviceType)
        formdata.append('regionId', this.formData.regionId)
        try {
          this.showLoading = true
          const res = await DeviceService.deviceKpiReadFile(formdata)
          if (res.code === 1000) {
            this.$router.push('/file/detail/' + res.data.id)
          } else {
            this.showFailMx(res.message)
          }
        } catch (e) {
          this.showFailMx(e.message)
        } finally {
          this.$refs.uploadFileExcel.value = null
          this.showLoading = false
        }
      },
      async fetchUser() {
        try {
          const response = await StaffService.getStaffById({
            userId: this.dataUser.userId,
          })
          if (response.success) {
            this.fullDataUser = {
              ...response.data,
            }
          }
          this.getAllRegionForUser(response.data)
        } catch (error) {
          console.log(error)
        }
      },
      getAllRegionForUser({ region, regionName }) {
        const result = []
        const regionNameArr = regionName.split(',')
        console.log({ region, regionNameArr })
        if (region?.length && regionNameArr?.length) {
          for (let i = 0; i < region.length; i++) {
            const id = region[i]
            const text = regionNameArr[i]
            result.push({ id, text })
          }
        }
        this.optionsRegion = result
      },
    },
  }
</script>
